import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { WorkOrderService } from '../../services/work-order/work-order.service';
import { UserPreferencesService } from '../../services/user-preferences/user-preferences.service';
import { LoaderService } from '../../services/loader/loader.service';
import { ToastService } from '../../services/toast/toast.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilsService } from '../../services/utils/utils.service';
import { lastValueFrom } from 'rxjs';
import { GridActionButtons } from '../../../shared/models/common.model';

@Component({
  selector: 'app-import-build-wo',
  standalone: false,
  templateUrl: './import-build-wo.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './import-build-wo.component.scss',
})
export class ImportBuildWoComponent implements OnInit {
  private workOrderService = inject(WorkOrderService);
  private userPreferencesService = inject(UserPreferencesService);
  private loaderService = inject(LoaderService);
  private toastService = inject(ToastService);
  private dialogRef = inject<MatDialogRef<ImportBuildWoComponent>>(MatDialogRef);
  data = inject<{
    workOrderData;
}>(MAT_DIALOG_DATA);
  private utilsService = inject(UtilsService);

  userPreferencesData: any;
  selectedFile: any[] = [];
  GridActionButtons = GridActionButtons;

  ngOnInit() {
    this.loadPreferenceData();
  }

  loadPreferenceData() {
    this.userPreferencesData =
      this.userPreferencesService.getUserPreferencesData();
  }
  
  onFileSelected(event: any) {
    const files = event.target.files;
    if (files && files.length > 0) {
      const invalidFiles = Array.from(files).filter(
        (file: File) =>
          !(
            file.name.endsWith('.xlsx') ||
            file.name.endsWith('.xls')
          )
      );

      if (invalidFiles.length > 0) {
        this.toastService.showError('Only xlsx and xls files are allowed.');
        this.selectedFile = [];
        return;
      }

      this.selectedFile = files;
    } else {
      this.selectedFile = [];
    }
  }

  async importFiles() {
    if (!this.selectedFile.length) {
      this.toastService.showWarning('Please select a file to upload.');
      return;
    }
    const companyId = this.userPreferencesData?.selectedCompanyId || 0;
    const userId = this.userPreferencesData?.userId || 0;

    const formData = new FormData();
    formData.append('companyId', companyId);
    formData.append('userId', userId);
    formData.append('fileName', this.selectedFile[0]);

    try {
      this.loaderService.showLoader();
      // Use httpService directly to get the binary response
      const response = await lastValueFrom(
        this.workOrderService.importBuildWO(formData)
      );

      // The response is a binary Excel file, so we need to download it
      const isSuccess = this.utilsService.downloadFile(
        response as Blob,
        'WO_Import_Result.xlsx',
        'excel'
      );

      if (isSuccess) {
        this.toastService.showSuccess(
          'File downloaded successfully. Please check the child Work Order list for the imported data.'
        );
        this.dialogRef.close();
      } else {
        this.toastService.showError('Error downloading the response file.');
      }
      this.loaderService.hideLoader();
    } catch (error) {
      console.error('Error uploading file:', error);
      this.toastService.showError(
        'Error processing the file. Please check the console for details.'
      );
      this.loaderService.hideLoader();
    }
  }

  removeFiles(event: any, fileInput: HTMLInputElement) {
    event.stopPropagation();
    this.selectedFile = [];
    fileInput.value = '';
  }

  cancel() {
    this.dialogRef.close();
  }
}
